// Keeps --vv-offset in sync with the viewport height iOS in-app browsers
// (Facebook, Instagram, LINE, WeChat, TikTok WKWebViews, etc.) hide behind
// their own bottom chrome, and with the on-screen keyboard height. Stock
// Safari/Chrome already reposition fixed elements above browser chrome, so
// this only ever measures the keyboard there and --vv-offset stays 0 the
// rest of the time.
export function initViewportOffsetSync() {
  const vv = window.visualViewport;
  if (!vv) return;

  const sync = () => {
    const offset = window.innerHeight - vv.height - vv.offsetTop;
    document.documentElement.style.setProperty('--vv-offset', `${Math.max(0, offset)}px`);
  };

  vv.addEventListener('resize', sync);
  vv.addEventListener('scroll', sync);
  sync();
}
